import React, { useState, useEffect } from 'react';

interface EmailSettingsProps {
  token: string;
}

const EmailSettings: React.FC<EmailSettingsProps> = ({ token }) => {
  const [settings, setSettings] = useState<any>({});
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');
  const [testSending, setTestSending] = useState(false);
  const [testMsg, setTestMsg] = useState('');

  const load = async () => {
    try {
      const res = await fetch('/api/admin/settings', { headers: { Authorization: 'Bearer ' + token } });
      if (res.ok) setSettings(await res.json());
    } catch (err) { console.error(err); }
  };

  useEffect(() => { load(); }, []);

  const save = async () => {
    setSaving(true); setMsg('');
    try {
      const res = await fetch('/api/admin/settings', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
        body: JSON.stringify(settings)
      });
      if (res.ok) setMsg('Settings saved');
      else setMsg('Failed to save');
    } catch (err) { setMsg('Error saving'); }
    setSaving(false);
  };

  const testEmail = async () => {
    setTestSending(true); setTestMsg('');
    try {
      const res = await fetch('/api/admin/settings/test-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
        body: JSON.stringify({ email: settings.backup_report_email || 'support@solvtek.co.uk' })
      });
      if (res.ok) setTestMsg('Test email sent! Check your inbox.');
      else setTestMsg('Failed: ' + ((await res.json()).error || 'unknown'));
    } catch (err) { setTestMsg('Error sending test'); }
    setTestSending(false);
  };

  const field = (key: string, label: string, type = 'text') => (
    <div style={{ marginBottom: '12px' }}>
      <label style={{ fontSize: '13px', fontWeight: 500, color: '#475569', display: 'block', marginBottom: '4px' }}>{label}</label>
      <input type={type} value={settings[key] || ''} onChange={e => setSettings({...settings, [key]: e.target.value})} style={{ width: '100%', padding: '10px', border: '1px solid #e5edf5', borderRadius: '6px', fontSize: '14px' }} />
    </div>
  );

  return (
    <div style={{ background: 'white', borderRadius: '8px', padding: '20px' }}>
      <h2>Email Settings</h2>
      <p style={{ fontSize: '13px', color: '#64748b', marginBottom: '16px' }}>Configure email for backup reports and notifications.</p>
      
      <h3 style={{ fontSize: '14px', color: '#1e3c72', marginBottom: '8px' }}>Backup Reports</h3>
      {field('backup_report_email', 'Report Email Address', 'email')}

      <h3 style={{ fontSize: '14px', color: '#1e3c72', marginBottom: '8px', marginTop: '16px' }}>SMTP (optional — fallback if Microsoft Graph fails)</h3>
      {field('smtp_host', 'SMTP Host')}
      {field('smtp_port', 'SMTP Port')}
      {field('smtp_user', 'SMTP Username')}
      {field('smtp_pass', 'SMTP Password', 'password')}
      {field('smtp_from', 'From Email', 'email')}

      <div style={{ display: 'flex', gap: '8px', marginTop: '16px', flexWrap: 'wrap' }}>
        <button onClick={save} disabled={saving} style={{ padding: '10px 20px', background: '#533afd', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '14px' }}>{saving ? 'Saving...' : 'Save Settings'}</button>
        <button onClick={testEmail} disabled={testSending} style={{ padding: '10px 20px', background: '#10b981', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '14px' }}>{testSending ? 'Sending...' : 'Send Test Email'}</button>
      </div>
      
      {msg && <div style={{ marginTop: '12px', padding: '10px', borderRadius: '6px', background: msg.includes('Saved') ? '#d1fae5' : '#fee2e2', color: msg.includes('Saved') ? '#065f46' : '#991b1b', fontSize: '13px' }}>{msg}</div>}
      {testMsg && <div style={{ marginTop: '8px', padding: '10px', borderRadius: '6px', background: testMsg.includes('sent') ? '#d1fae5' : '#fee2e2', color: testMsg.includes('sent') ? '#065f46' : '#991b1b', fontSize: '13px' }}>{testMsg}</div>}
    </div>
  );
};

export default EmailSettings;
